(function () {
  if (window.__ssLangSwitch) return;
  window.__ssLangSwitch = true;

  function place() {
    const source = document.querySelector('[data-ss-lang]');
    if (!source || source.dataset.placed === 'true') return;

    const actions = document.querySelector('header-actions');
    if (!actions) return;

    source.dataset.placed = 'true';
    source.removeAttribute('hidden');
    actions.insertAdjacentElement('afterbegin', source);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }

  document.addEventListener('shopify:section:load', place);
})();